export default __webpack_public_path__ + "static/media/title.1d7a33ec.svg";